module.exports = __webpack_public_path__ + "3b5705c3be3b6ca65d51d6a67fa5a620.pdf";